import script from "./ParameterExpandModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ParameterExpandModal.vue?vue&type=script&setup=true&lang=ts"

import "./ParameterExpandModal.vue?vue&type=style&index=0&id=c24dcd36&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c24dcd36"]])

export default __exports__